import { useEffect, useState } from "react";
import { formatNumber } from "../services";
import {
  Container,
  GalleryHeader,
  ImageGallery,
} from "../Components";

const pics = [
  {
    title: "robot",
  },
  {
    title: "tablet",
  },
  {
    title: "monitor",
  },
  {
    title: "camera",
  },
  {
    title: "men",
  },
  {
    title: "robot2",
  },
  {
    title: "camera",
  },
  {
    title: "men",
  },
  {
    title: "robot",
  },
  {
    title: "tablet",
  },
  {
    title: "monitor",
  },
  {
    title: "camera",
  },
  {
    title: "men",
  },
  {
    title: "robot2",
  },
  {
    title: "robot",
  },
  {
    title: "tablet",
  },
  {
    title: "monitor",
  },
  {
    title: "camera",
  },
  {
    title: "men",
  },
  {
    title: "robot2",
  },
];
function Gallery() {
  /*
   *Stores Number of Image
   */
  const [length, setLength] = useState();
  /*
   *Format number of images with comma(,)
   */
  useEffect(() => {
    setLength(formatNumber(pics.length));
  }, []);
  return (
    // <div className="mt-7">
      <Container>
        <GalleryHeader title="Gallery" />
        {/* <GalleryInfo  /> */}
        <ImageGallery title={"All images"} length={length} pics={pics} />
      </Container>
    // </div>
  );
}

export default Gallery;
